export enum SalesContext {
    POS = "POS",
    BOXOFFICE = "BOXOFFICE",
    ECOMMERCE = "ECOMMERCE",
    SQUARE_ECOMMERCE = "SQUARE_ECOMMERCE"
}
